import { styled } from '@mui/system';
import { Typography } from '@mui/material';
import { theme } from '../../lib/index';

export const StyledCounter = styled(Typography, {})({
  position: 'absolute',
  right: 5,
  bottom: -10,

  color: theme.palette.placeholdergrey,
  fontSize: 10,
  lineHeight: '17px',
});
